export default __webpack_public_path__ + "static/media/ic_zones_selected.b17b41b1.svg";